import * as z from 'zod';
import { Get as Get$1, Close as Close$2 } from './bid-contract-surety-bond.dto.mjs';
import * as bidContractSuretyBond_dto from './bid-contract-surety-bond.dto.mjs';
export { bidContractSuretyBond_dto as Bid };
import { Get as Get$2, Close as Close$1 } from './final-contract-surety-bond.dto.mjs';
import * as finalContractSuretyBond_dto from './final-contract-surety-bond.dto.mjs';
export { finalContractSuretyBond_dto as Final };

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.discriminatedUnion("contractSuretyType", [
            Get$1.Response.schema,
            Get$2.Response.schema,
        ]);
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Close;
(function (Close) {
    (function (Request) {
        Request.schema = z.discriminatedUnion("contractSuretyType", [
            Close$1.Request.schema,
            Close$2.Request.schema,
        ]);
    })(Close.Request || (Close.Request = {}));
})(Close || (Close = {}));

export { Close, Get };
